import { render, staticRenderFns } from "./SpecialConfig.vue?vue&type=template&id=317a7981&scoped=true&"
import script from "./SpecialConfig.vue?vue&type=script&lang=js&"
export * from "./SpecialConfig.vue?vue&type=script&lang=js&"
import style0 from "./SpecialConfig.vue?vue&type=style&index=0&id=317a7981&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317a7981",
  null
  
)

export default component.exports